export enum NotificationType {
  System = "system",
  Follow = "follow",
  Message = "message",
  Comment = "comment",
  Like = "like",
  Mention = "mention",
}

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  content: string;
  createdAt: Date;
  isRead: boolean;
  link?: string;
  metadata?: Record<string, unknown>;
}

export interface SystemNotification extends Notification {
  type: NotificationType.System;
}

export interface MentionNotification extends Notification {
  type: NotificationType.Mention;
  mentionedIn: {
    entityType: "artwork" | "comment";
    entityId: string;
  };
  mentionedBy: {
    userId: string;
    username: string;
    nickname: string;
    avatarUrl: string;
  };
}
